import {
    OnChanges,
    OnDestroy,
    AfterViewChecked,
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output
} from "@angular/core";
import { SafeResourceUrl } from "@angular/platform-browser";

// Name of the custom event to listent to
const IFRAME_EVENT = "IFRAME_EVENT";

@Component({
    selector: "ng-iframe",
    templateUrl: "./ng-iframe.component.html",
    styleUrls: ["./ng-iframe.component.less"]
})
export class NgIFrameComponent implements AfterViewInit, AfterViewChecked, OnChanges, OnDestroy {
    @Input() sanitizedUrl: SafeResourceUrl;
    @Output() output: EventEmitter<any> = new EventEmitter();

    /**
     * Store the document event listener function as signature for ngOnDestroy reference
     * https://stackoverflow.com/questions/10444077/javascript-removeeventlistener-not-working
     */
    private eventListenerSignature = this.reactOutput.bind(this);

    constructor(public el: ElementRef) {
        window.document.addEventListener(IFRAME_EVENT, this.eventListenerSignature, true);
    }

    ngOnChanges() {
    }

    ngAfterViewInit(): void {
    }

    ngAfterViewChecked(): void {
    }

    ngOnDestroy(): void {
        window.document.removeEventListener(IFRAME_EVENT, this.eventListenerSignature, true);
    }

    reactOutput($event: CustomEvent) {
        console.warn("Reacting to event from shared", $event);
        this.output.emit($event.detail);
    }
}
